module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.discount !== null) ? _c('div', [_c('discount-form', {
    attrs: {
      "discount": _vm.discount
    },
    on: {
      "saved": _vm.reloadDiscount
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7afd1821"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/discounts/DiscountEdit.vue
// module id = 562
// module chunks = 0